import { LocationOption } from "./types";

export const itemTemplate = (
  option: LocationOption,
  icon: string = "pi-map-marker",
) => (
  <div className="flex align-items-center gap-2 px-2 py-1">
    <i className={`pi ${icon} text-primary`} />
    <span className="text-sm text-color">{option.label}</span>
  </div>
);

export const valueTemplate = (
  option?: LocationOption,
  icon: string = "pi-map-marker",
) => {
  if (!option?.label)
    return <span className="text-color-secondary">Select Location</span>;

  return (
    <div className="flex align-items-center gap-2">
      <i className={`pi ${icon} text-primary`} />
      <span>{option.label}</span>
    </div>
  );
};
